import _ from 'underscore';
import $ from 'jquery';
import Backbone from 'backbone';
import { pgridFactory } from '@bingads-webui-campaign/pgrid-factory';
import { uncheckedInjectionContext as globalContext } from '@bingads-webui-campaign/injection-context';
import { updateGridQuery } from '@bingads-webui-campaign/summary-grid-helper';

import FooterView from './grid-footer-view';

const edm = globalContext.requireDefault('component/edm-campaign/index');
const jsdataCampaign = globalContext.require('component/js-data-campaign/index');
const globalI18n = globalContext.require('$/i18n!global');
const i18n = globalContext.require('@bingads-webui/i18n-amd-loader!campaignui/feature/dimension');
const instrumentation = globalContext.requireDefault('campaignui/feature/instrumentation/index');

export class DimensionGrid extends Backbone.View {
  initialize({
    isForVNext,
    filterService,
    getGridConfig,
    getPlugins,
    setupDataSourceErrorHandling,
    preferenceConfig,
    gridType,
    entityName = 'campaign',
  }) {
    this.initializeInstrumentation();

    this.gridType = gridType;
    this.classNames = ['grid'];
    this.isForVNext = isForVNext;
    this.filterService = filterService;
    this.entityName = entityName;
    this.entity = this.getEntity(this.entityName);
    this.config = getGridConfig(this);
    this.grid = pgridFactory({
      gridConfig: this.config,
      plugins: getPlugins(this),
      preferenceConfig,
    });
    this.dataSource = this.config.dataSource;

    const {
      gridView,
      toolbar,
      columnChooser,
      inlineDownload,
    } = this.grid;

    this.activities.loadDimensionGrid.trace('dimension grid loaded', this.activities.loadDimensionGrid.value);
    this.activities.loadDimensionGrid.trace(`{"gridType": ${gridType}}`, 'Dimension/load');
    this.gridView = gridView;
    this.toolbar = toolbar;
    this.columnChooser = columnChooser;
    this.inlineDownload = inlineDownload;

    this.footerView = new FooterView({
      gridType,
      i18n: globalI18n,
    });

    if (isForVNext) {
      this.filterService.on('filter-state-changed', () => {
        updateGridQuery(
          this.grid.gridView,
          this.filterService.getCombinedFilter(), true
        );
      });
    }

    this.gridView.on('willUpdate', () => {
      $('.dimension-grid .placeholder-plugin').hide();
      $('.dimension-grid .grid-noresult.grid-fail').hide();
    }, this);

    this.gridView.on('didUpdate', () => {
      if (this.isErrorCall) {
        $('.dimension-grid .grid-noresult.grid-fail').show();
        $('.dimension-grid .placeholder-plugin').hide();
      }
    }, this);

    setupDataSourceErrorHandling(this);
  }

  initializeInstrumentation() {
    const scenarios = {
      viewDimensionGrid: instrumentation.viewDimensionGrid.create(),
    };

    this.activities = {
      loadDimensionGrid: scenarios.viewDimensionGrid.loadDimensionGrid.create(),
      loadDimensionColumns: scenarios.viewDimensionGrid.loadDimensionColumns.create(),
      filterDimensionGrid: scenarios.viewDimensionGrid.filterDimensionGrid.create(),
    };
  }

  afterFindAllCallback(resource, data) {
    let errorMsg = null;

    if (data.status === 500) {
      this.isErrorCall = true;
      errorMsg = i18n.getString('Dimension_GenericErrorMessage');
      this.inlineDownload.setAvailability(false);
      if (this.isForVNext) {
        this.showTooMuchDataError = true;
        this.errorMessage = errorMsg;
        $('.dimensions-table .grid-noresult').html(errorMsg).show();
      } else {
        $('.dimension-grid .placeholder-plugin').hide();
        $('.dimension-grid .grid-noresult.grid-fail').html(errorMsg).show();
        $('#dimension-tab .perfDataExplanation').show();
      }
    } else if (data.errors) {
      this.isErrorCall = true;
      if (_.some(data.errors, error => error.Code === 'TooMuchDataToDownload')) {
        errorMsg = i18n.getString('Dimension_TooMuchDataToDownload');
        this.inlineDownload.setAvailability(true);
      } else if (_.some(data.errors, error => error.Code === 'TooMuchDataForInlineDownload')) {
        errorMsg = i18n.getString('Dimension_TooMuchDataToInlineDownload');
        this.inlineDownload.setAvailability(false);
      } else if (_.some(data.errors, error => error.Code === 'TooMuchExcelDataToDownload')) {
        errorMsg = i18n.getString('Dimension_TooMuchExcelDataToDownload');
        this.inlineDownload.setAvailability(true);
      } else if (data.errors && !_.isEmpty(data.errors)) {
        errorMsg = i18n.getString('Dimension_GenericErrorMessage');
        this.inlineDownload.setAvailability(false);
      }
      if (this.isForVNext) {
        this.showTooMuchDataError = true;
        this.errorMessage = errorMsg;
        $('.dimensions-table .grid-noresult').html(errorMsg).show();
      } else {
        $('.dimension-grid .placeholder-plugin').hide();
        $('.dimension-grid .grid-noresult.grid-fail').html(errorMsg).show();
        $('#dimension-tab .perfDataExplanation').show();
      }
    } else {
      this.isErrorCall = false;
      this.showTooMuchDataError = false;
      $('.dimension-grid .placeholder-plugin').show();
      $('.dimension-grid .grid-noresult.grid-fail').hide();
      if (data.length > 0) {
        $('#dimension-tab .perfDataExplanation').hide();
      }

      this.inlineDownload.setAvailability(true);
    }

    return data;
  }

  get tooMuchDataDownloadErrorText() {
    if (this.showTooMuchDataError) {
      return this.errorMessage;
    }
    return null;
  }

  getEntity(entityName) {
    switch (entityName) {
      case 'adgroup':
        return jsdataCampaign.AdGroup;
      case 'keyword':
        return jsdataCampaign.Keyword;
      case 'ad':
        return jsdataCampaign.Ad;
      case 'campaign':
      default:
        return jsdataCampaign.Campaign;
    }
  }

  getCurrentEntityFromEdm() {
    return edm.currentAdGroup ||
      edm.currentCampaign ||
      edm.currentAccount ||
      edm.currentCustomer.Accounts;
  }

  render() {
    this.footerView.render();
    // eslint-disable-next-line no-underscore-dangle
    if (this.gridView._isRendered) {
      // force a gridview refresh if it has been rendered already
      // this is to avoid gridview rerender which causes issues such as
      // pagination control loses all its event bindings
      this.gridView.refresh(true);
    } else {
      this.gridView.render();
    }
    this.$el.append(this.gridView.el);

    return this;
  }

  remove() {
    this.gridView.remove();
    this.toolbar.gridToolbarGroup.remove();
    this.columnChooser.remove();
    this.inlineDownload.remove();

    super.remove();
  }
}
